const HTTP_PROTOCOL_RE = /^https?:\/\//i;
const ANY_PROTOCOL_RE = /^[a-z][a-z0-9+.-]*:/i;
const WHITESPACE_RE = /\s/;
const PHONE_ALLOWED_CHARS_RE = /^[0-9+\s().\-/#xX]+$/;

export const normalizeHarbormasterWebsite = value => {
  const trimmed = typeof value === 'string' ? value.trim() : '';

  if (!trimmed) {
    return null;
  }

  return HTTP_PROTOCOL_RE.test(trimmed) ? trimmed : `https://${trimmed}`;
};

export const isValidHarbormasterWebsite = value => {
  const rawValue = typeof value === 'string' ? value.trim() : '';
  const usesUnsupportedProtocol = ANY_PROTOCOL_RE.test(rawValue) && !HTTP_PROTOCOL_RE.test(rawValue);

  if (usesUnsupportedProtocol) {
    return false;
  }

  const normalizedWebsite = normalizeHarbormasterWebsite(value);

  if (!normalizedWebsite) {
    return true;
  }

  if (WHITESPACE_RE.test(normalizedWebsite)) {
    return false;
  }

  try {
    const url = new URL(normalizedWebsite);
    return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname);
  } catch (e) {
    return false;
  }
};

export const isValidHarbormasterPhone = value => {
  const trimmed = typeof value === 'string' ? value.trim() : '';

  if (!trimmed) {
    return true;
  }

  const digits = trimmed.match(/\d/g) || [];
  const plusSigns = trimmed.match(/\+/g) || [];
  const hasInvalidPlus = plusSigns.length > 1 || (plusSigns.length === 1 && trimmed[0] !== '+');

  return (
    PHONE_ALLOWED_CHARS_RE.test(trimmed) &&
    !hasInvalidPlus &&
    digits.length >= 7 &&
    digits.length <= 20
  );
};

export const sanitizeHarbormasterPhoneForTel = value => {
  const trimmed = typeof value === 'string' ? value.trim() : '';

  if (!trimmed) {
    return null;
  }

  const withoutExtension = trimmed.replace(/\s*(?:ext\.?|x|#)\s*\d+\s*$/i, '');
  const sanitized = withoutExtension.replace(/[^\d+]/g, '');

  return sanitized || null;
};
